module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.29d0602.ttf";